import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  InfoCircleFilled,
  SearchOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import {
  Col,
  Row,
  Table,
  Image,
  Badge,
  Modal,
  message,
  Tabs,
  Alert,
  ConfigProvider,
  Form,
} from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button/Button";
import { CardContainer } from "../../components/Card/CardContainer";
import { FlexCol, FlexRow } from "../../components/Container/Container";
import Input from "../../components/Input/Input";
import Select from "../../components/Select/Select";
import Text from "../../components/Text/Text";
import { color, icon } from "../../resource";
import image from "../../resource/image";
import { dateFormatter } from "../../utility/Formatter";
import { useEffectOnce } from "react-use";
import Permission from "../../components/Permission/Permission";
import { deleteHighlight, getHighlightList, getShopHighlightById } from "../../datasource/News";
import { zoneDatasource } from "../../datasource/ZoneDatasource";
import { getShopGroup } from "../../datasource/ShopGroupDatasoure";
import { useMessageContext } from "../../context/MessageProvider";

const appList = [
  {
    key: "SHOP",
    name: "Shop App",
    icon: <img src={image.iconShopApp} width='20px' height='20px' />,
  },
  {
    key: "SALE",
    name: "Sale App",
    icon: <img src={image.iconSaleApp} width='20px' height='20px' />,
  },
];

export const HighLightNews: React.FC = () => {
  const navigate = useNavigate();
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { company, firstname, lastname } = userProfile;
  const { messageApi } = useMessageContext();

  const pageSize = 10;

  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState<string>();
  const [app, setApp] = useState<string>();
  const [page, setPage] = useState<number>(1);
  const [dataState, setDataState] = useState<any>();
  const [deletingId, setDeletingId] = useState<string>();
  const [tab, setTab] = useState<string>("ALL");
  const [modalInfoShop, setModalInfoShop] = useState({ open: false, highlightId: undefined });

  const resetPage = () => setPage(1);

  useEffect(() => {
    if (!loading) fetchData();
  }, [keyword, app, page, tab]);

  useEffectOnce(() => {
    fetchData();
  });

  const fetchData = async () => {
    try {
      setLoading(true);
      const { responseData } = await getHighlightList({
        company,
        take: pageSize,
        searchText: keyword,
        application: app,
        page,
        status: tab === "ALL" ? undefined : tab,
      });
      setDataState(responseData);
    } catch (e) {
      console.log(e);
    } finally {
      setTimeout(() => setLoading(false), 300);
    }
  };

  const ActionBtn = ({ onClick, icon }: any) => {
    return (
      <Col span={6}>
        <div className='btn btn-icon btn-light btn-hover-primary btn-sm' onClick={onClick}>
          <span
            className='svg-icon svg-icon-primary svg-icon-2x'
            style={{ color: color["primary"] }}
          >
            {icon}
          </span>
        </div>
      </Col>
    );
  };

  const PageTitle = (
    <Row gutter={16}>
      <Col span={12}>
        <Text level={3} fontWeight={700}>
          ข่าวสารไฮไลท์
        </Text>
      </Col>
      <Col span={4}>
        <Input
          placeholder='ค้นหาชื่อข่าวสาร'
          prefix={<SearchOutlined style={{ color: "grey" }} />}
          defaultValue={keyword}
          onPressEnter={(e) => {
            const value = (e.target as HTMLTextAreaElement).value;
            setKeyword(value);
            resetPage();
          }}
          onChange={(e) => {
            const value = (e.target as HTMLInputElement).value;
            if (!value) {
              setKeyword("");
              resetPage();
            }
          }}
        />
      </Col>
      <Col span={4}>
        <Select
          allowClear
          onChange={(value: string) => {
            setApp(value);
            resetPage();
          }}
          placeholder='เลือกแอปพลิเคชัน'
          data={appList.map(({ key, name, icon }) => ({
            key,
            label: (
              <span>
                {icon}&nbsp;{name}
              </span>
            ),
            value: key,
          }))}
          style={{ width: "100%" }}
          value={app}
        />
      </Col>
      <Permission permission={["newsList", "create"]}>
        <Col className='gutter-row' span={4}>
          <Button
            type='primary'
            title='+ เพิ่มข่าวสารไฮไลท์'
            height={40}
            onClick={() => navigate("/news/createhighlight")}
          />
        </Col>
      </Permission>
    </Row>
  );

  const columns: any = [
    {
      title: "วันที่เผยแพร่",
      dataIndex: "date",
      key: "date",
      width: "15%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Row>
              <Text level={5}>{dateFormatter(row.startDate, true)}</Text> -{" "}
              <Text level={5}>{dateFormatter(row.endDate, true)}</Text>
            </Row>
          ),
        };
      },
    },
    {
      title: "ชื่อข่าวสาร",
      dataIndex: "topic",
      key: "topic",
      width: "22%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexRow style={{ alignItems: "center", gap: "10px" }}>
              <Image
                src={row.newsImage}
                height={60}
                width={60}
                style={{ borderRadius: "5px", objectFit: "cover" }}
              />
              <Text level={5}>{value || "-"}</Text>
            </FlexRow>
          ),
        };
      },
    },
    {
      title: "รูปแบบ",
      dataIndex: "type",
      key: "type",
      render: (value: any, row: any, index: number) => {
        return {
          children: <Text>{value === "NEWS" ? "ข่าวสาร" : "Flash Sale"}</Text>,
        };
      },
    },
    {
      title: "ร้านค้า",
      dataIndex: "countShop",
      key: "countShop",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexRow style={{ alignItems: "center", gap: "8px" }}>
              <Text>{value || 0} ร้าน</Text>
              <InfoCircleFilled
                style={{ fontSize: "16px", cursor: "pointer" }}
                onClick={() => setModalInfoShop({ open: true, highlightId: row.highlightNewsId })}
              />
            </FlexRow>
          ),
        };
      },
    },
    {
      title: "แอปพลิเคชัน",
      dataIndex: "application",
      key: "application",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Row gutter={16} justify={"space-between"}>
              {row.isShowOnSaleApp && (
                <Col span={24}>
                  <Image src={image.iconSaleApp} height={25} preview={false} />
                  <Text level={5} style={{ paddingLeft: "5px" }}>
                    Sale App
                  </Text>
                </Col>
              )}
              {row.isShowOnShopApp && (
                <Col span={24}>
                  <Image src={image.iconShopApp} height={25} preview={false} />
                  <Text level={5} style={{ paddingLeft: "5px" }}>
                    Shop App
                  </Text>
                </Col>
              )}
            </Row>
          ),
        };
      },
    },
    {
      title: "กดลิ้งแล้ว",
      dataIndex: "reader",
      key: "reader",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Row gutter={16} justify={"space-between"}>
              <Col span={24}>
                <Text level={5} style={{ paddingLeft: "5px" }}>
                  {row.viewSaleApp}
                </Text>
              </Col>
              <Col span={24}>
                <Text level={5} style={{ paddingLeft: "5px" }}>
                  {row.viewShopApp}
                </Text>
              </Col>
            </Row>
          ),
        };
      },
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      render: (status: any, row: any, index: number) => {
        return {
          children: (
            <>
              <Row gutter={8}>
                <Col>
                  <Badge status={status === "PUBLISHED" ? "success" : "default"} />
                </Col>
                <Text level={5}>{status === "PUBLISHED" ? "ใช้งาน" : "ปิดใช้งาน"}</Text>
              </Row>
              <Text level={6} color='Text3'>
                {row.updatedBy}
              </Text>
            </>
          ),
        };
      },
    },
    {
      title: "จัดการ",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      width: "8%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexRow justify={"start"} style={{ gap: "8px" }}>
              <Col>
                <ActionBtn
                  onClick={() => {
                    navigate(`/news/edithighlight/${row.highlightNewsId}`);
                  }}
                  icon={row.type === "FLASH_SALE" ? <UnorderedListOutlined /> : <EditOutlined />}
                />
              </Col>
              <Col>
                {row.type !== "FLASH_SALE" && (
                  <ActionBtn
                    onClick={() => setDeletingId(row.highlightNewsId)}
                    icon={<DeleteOutlined style={{ color: color.error }} />}
                  />
                )}
              </Col>
            </FlexRow>
          ),
        };
      },
    },
  ];

  return (
    <>
      <CardContainer>
        {PageTitle}
        <br />
        <Alert
          icon={<ExclamationCircleOutlined style={{ fontSize: "20px" }} />}
          showIcon
          description={
            <Text level={6}>ไฮไลน์ข่าวสารไม่สามารถแสดงทับซ้อนในช่วงเวลาเดียวกันได้</Text>
          }
          style={{
            padding: "8px",
            borderRadius: "4px",
            border: "none",
            backgroundColor: "#F3F6F9",
            alignItems: "center",
          }}
        />
        <Tabs
          activeKey={tab}
          onChange={(key) => setTab(key)}
          items={[
            {
              label: (
                <Text level={6}>
                  ทั้งหมด ({dataState?.countStatus?.reduce((acc, s) => acc + s.count, 0) ?? 0})
                </Text>
              ),
              key: "ALL",
            },
            {
              label: (
                <Text level={6}>
                  เปิดใช้งาน (
                  {dataState?.countStatus?.find((s) => s.status === "PUBLISHED")?.count ?? 0})
                </Text>
              ),
              key: "PUBLISHED",
            },
            {
              label: (
                <Text level={6}>
                  ปิดใช้งาน (
                  {dataState?.countStatus?.find((s) => s.status === "INACTIVE")?.count ?? 0})
                </Text>
              ),
              key: "INACTIVE",
            },
            {
              label: (
                <Text level={6}>
                  แบบร่าง ({dataState?.countStatus?.find((s) => s.status === "DRAFT")?.count ?? 0})
                </Text>
              ),
              key: "DRAFT",
            },
          ]}
        />
        <Table
          className='rounded-lg'
          columns={columns}
          scroll={{ x: 1500 }}
          dataSource={dataState?.data}
          size='large'
          tableLayout='fixed'
          loading={loading}
          pagination={{
            position: ["bottomCenter"],
            pageSize,
            current: page,
            total: dataState?.count,
            onChange: (p) => setPage(p),
            showSizeChanger: false,
          }}
        />
        {deletingId && (
          <Modal
            centered
            open={!!deletingId}
            onOk={async () => {
              if (deletingId) {
                await deleteHighlight({
                  highlightNewsId: deletingId,
                  updateBy: firstname + " " + lastname,
                })
                  .then((res) => {
                    setDeletingId(undefined);
                    messageApi.open({
                      type: "error",
                      content: "ลบรายการแล้ว",
                      icon: <img src={icon.delete} style={{ width: 14, height: 16 }} />,
                    });
                    fetchData();
                  })
                  .catch(() => message.error("ลบโปรโมชั่นไม่สำเร็จ"));
              }
            }}
            onCancel={() => setDeletingId(undefined)}
            destroyOnClose
            okText={"ยืนยัน"}
            okButtonProps={{ style: { backgroundColor: color.error, borderColor: color.error } }}
            cancelButtonProps={{ style: { color: color.error, borderColor: color.error } }}
          >
            <Text level={2}>ต้องการยืนยันการลบ</Text>
            <br />
            <Text level={5} color='Text3'>
              โปรดตรวจสอบข่าวสารที่คุณต้องการลบ ก่อนกดยืนยัน
              <br />
              เพราะอาจส่งผลต่อการทำงานของผู้ดูแลระบบ
            </Text>
          </Modal>
        )}
      </CardContainer>
      {modalInfoShop && (
        <ModalInfoShop
          open={modalInfoShop?.open}
          onClose={() => setModalInfoShop({ open: false, highlightId: undefined })}
          highlightId={modalInfoShop?.highlightId}
          company={company}
        />
      )}
    </>
  );
};

const ModalInfoShop = ({ open, onClose, highlightId, company }: any) => {
  const [formShop] = Form.useForm();
  const watchSearchShop = Form.useWatch("searchShop", formShop);
  const [zoneList, setZoneList] = useState<any>([]);
  const [cusGroupList, setCusGroupList] = useState<any>([]);

  const [searchZone, setSearchZone] = useState<any>(undefined);
  const [searchGroup, setSearchGroup] = useState<any>(undefined);
  const [searchText, setSearchText] = useState<any>(undefined);

  const fetchZone = async () => {
    await zoneDatasource.getAllZoneByCompany(company).then((res) => {
      setZoneList(res);
    });
  };
  const fetchCustomerGroup = async () => {
    await getShopGroup({ page: 1, take: 999, company: company, isActive: true }).then((res) => {
      const mapData = res.responseData.data.map((group: any) => ({
        label: group.customerGroupName,
        value: group.customerGroupName,
        key: group.customerGroupName,
      }));
      setCusGroupList(mapData);
    });
  };

  useEffectOnce(() => {
    fetchZone();
    fetchCustomerGroup();
  });

  const fetchData = async () => {
    const { responseData } = await getShopHighlightById({
      highlightNewsId: highlightId,
    }).then((res) => res);
    formShop.setFieldsValue({ searchShop: responseData.data, shops: responseData.data || [] });
  };

  useEffect(() => {
    fetchData();
  }, [highlightId, formShop]);

  const onSearchShop = (zone: any, group: any, text: any) => {
    const mapShop = formShop.getFieldValue("shops");
    const mapSearchShopList = mapShop.filter((shop: any) => {
      const isMatchZone = zone ? shop.zone === zone : true;
      const isMatchGroup = group ? shop.customerGroupName === group : true;
      const isMatchText = text
        ? shop.customerName.toLowerCase().includes(text.toLowerCase()) ||
          shop.customerNo.toLowerCase().includes(text.toLowerCase())
        : true;
      return isMatchZone && isMatchGroup && isMatchText;
    });
    formShop.setFieldsValue({
      ...formShop.getFieldsValue(true),
      searchShop: mapSearchShopList,
    });
  };

  const columes = [
    {
      title: "ชื่อร้านค้า",
      dataIndex: "customerName",
      key: "customerName",
      width: "30%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value}</Text>
              <Text color='Text3'>
                {row.customerNo} • เขต {row.zone} • กลุ่ม {row.customerGroupName || "-"}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "เขต",
      dataIndex: "zone",
      key: "zone",
      width: "10%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value || "-"}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "กลุ่มร้านค้า",
      dataIndex: "customerGroupName",
      key: "customerGroupName",
      width: "10%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value || "-"}</Text>
            </FlexCol>
          ),
        };
      },
    },
  ];

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={1000}
      title={
        <Text fontWeight={600} level={4}>
          ร้านที่เห็นไฮไลท์ {formShop.getFieldValue("shops")?.length || 0} ร้าน
        </Text>
      }
    >
      <Row justify={"space-between"} gutter={8}>
        <>
          <Col span={17}>
            <Input
              value={searchText}
              placeholder='ค้นหาชื่อร้านค้า'
              suffix={<SearchOutlined />}
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              onPressEnter={(e) => {
                setSearchText(e.currentTarget.value);
                onSearchShop(searchZone, searchGroup, e.currentTarget.value);
              }}
            />
          </Col>
          <Col span={3}>
            <Select
              value={searchZone}
              data={
                zoneList?.map((zone) => ({
                  label: zone.zoneName,
                  value: zone.zoneName,
                  key: zone.zoneName,
                })) || []
              }
              placeholder='เลือกเขต'
              style={{ width: "100%" }}
              onChange={(e) => {
                setSearchZone(e);
                onSearchShop(e, searchGroup, searchText);
              }}
            />
          </Col>
          <Col span={4}>
            <Select
              value={searchGroup}
              data={
                cusGroupList?.map((group) => ({
                  label: group.label,
                  value: group.value,
                  key: group.key,
                })) || []
              }
              placeholder='กลุ่มร้านค้า'
              style={{ width: "100%" }}
              onChange={(e) => {
                setSearchGroup(e);
                onSearchShop(searchZone, e, searchText);
              }}
            />
          </Col>
        </>
      </Row>
      <br />
      <Form form={formShop} layout='vertical' preserve={false}>
        <ConfigProvider
          theme={{
            components: {
              Table: {
                headerBg: "#F3F6F9",
                headerColor: "black",
                fontFamily: "IBM Plex Sans Thai",
                fontSize: 15,
              },
            },
          }}
        >
          <Form.Item name='searchShop' noStyle>
            <Table
              size='small'
              columns={columes}
              dataSource={formShop?.getFieldValue("searchShop") || []}
              rowKey='customerCompanyId'
              tableLayout='fixed'
              scroll={{
                y: 400,
              }}
              pagination={false}
            />
          </Form.Item>
        </ConfigProvider>
      </Form>
    </Modal>
  );
};
